import React, { useEffect, useState } from 'react';
import {
  ExtBrowsingCapabilities,
  GetExtBrowsingCapsArgs,
  GetExtBrowsingCapsQuery
} from '../../autogenerated/ZoomBridge';
import Dropdown from '../../common/Dropdown';
import Separator from '../../common/form/Separator';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import Authenticator from '../../protocol/Authenticator';
import HashMap from '../../protocol/HashMap';
import { HeightLeftWithoutHeaderInCalc } from '../../util/ScreenUtil';
import './BrowseExt.css';
import BrowseExtDirectory from './BrowseExtDirectory';
import { BrowseExtUtil } from './BrowseExtUtil';
function BrowseExt() {
  const style = { height: HeightLeftWithoutHeaderInCalc };
  const [buckets, setBuckets] = useState([]);
  const [activeBucket, setActiveBucket] = useState(null);
  
  useEffect(() => {
    fetchBuckets();
  }, []);

  const fetchBuckets = () => {
    BrowseExtUtil.fetchBuckets().then((res: ExtBrowsingCapabilities) => {
      setBuckets(castBuckets(res.getTargetToOps()));
    }).catch((err) => {
      ErrorHandler.handleError(err)
    });
  };

  const castBuckets = (bucketMap: HashMap) => {
    const buckets = [];
    const bucketArray = Array.from(bucketMap.keys());
    bucketArray.forEach((val, index) => {
      const bucket = {};
      bucket.label = val;
      bucket.value = index;
      bucket.selected = !index ? 'selected' : null;
      buckets.push(bucket);
    });

    return buckets;
  };

  return (
    <div name="BrowseExt" className="flex-row">
      <div className="browse-ext-container flex-col" style={style}>
        <div className="dropdown-container flex-row">
          <Dropdown
            value={activeBucket}
            options={buckets}
            placeholder={t('CHOOSE_STORAGE_NAME')}
            onChange={(value) => {
              setActiveBucket(value);
            }}></Dropdown>
        </div>
        <Separator></Separator>
        {buckets.length ? <BrowseExtDirectory  bucketName={buckets[activeBucket]?.label}></BrowseExtDirectory> : null}
      </div>
    </div>
  );
}

export default BrowseExt;
